<ng-container
	*ngIf="{
		loading: loading | async,
		isConfirmationVisible: isConfirmationVisible | async,
		showNewsletterInfo: showNewsletterInfo | async,
		formInvalid: formInvalid$ | async,
	} as viewData"
>
	<div class="auth-container">
		<sf-auth-top-bar></sf-auth-top-bar>
		<div class="auth-content">
			<mat-progress-bar *ngIf="viewData.loading" mode="indeterminate"></mat-progress-bar>
			<div class="auth-content-inner">
				<div *ngIf="!viewData.isConfirmationVisible; else confirmation" class="sign-in-form" [formGroup]="form">
					<h3 class="sf title">{{ 'sf.module.auth.sign_up.create_account' | translate }}</h3>
					<span class="caption">{{ 'sf.module.auth.sign_up.caption' | translate }}</span>
					<div class="fields">
						<div class="field-wrapper">
							<sf-input
								id="signUpEmail"
								formControlName="email"
								type="email"
								[placeholder]="'sf.module.auth.common.email' | translate"
							>
								<span *ngIf="emailControl.hasError('usernameExists')"
									>{{ 'sf.common.validation.errors.email_taken' | translate }}
								</span>
							</sf-input>
						</div>
						<div class="field-wrapper">
							<sf-input-password
								class="top"
								id="signUpPassword"
								formControlName="password"
								[showPasswordHint]="true"
								[placeholder]="'sf.module.auth.common.password' | translate"
								(blurEvent)="onPasswordBlur()"
							>
							</sf-input-password>
						</div>

						<div class="field-wrapper repeat-password">
							<sf-input-password
								class="top"
								id="signUpRepeatPassword"
								formControlName="passwordRepeat"
								[placeholder]="'sf.module.auth.common.repeat_password' | translate"
							>
								<span *ngIf="passwordRepeatControl.hasError('confirmedValidator')"
									>{{ 'sf.common.validation.errors.field_password_match' | translate }}
								</span>
							</sf-input-password>
						</div>
						<div class="checkbox-group">
							<div class="field-wrapper">
								<mat-checkbox formControlName="policyAndTerms" id="policyAndTerms">
									<span
										[innerHTML]="
											'sf.module.auth.sign_up.agreement_info'
												| translate: { policy: '/assets/documents/privacy_policy.pdf' }
										"
									></span>
									<mat-error
										*ngIf="policyAndTermsControl.hasError('required') && policyAndTermsControl.dirty"
										class="checkbox-error"
										>{{ 'sf.common.validation.errors.field_required' | translate }}</mat-error
									>
								</mat-checkbox>
							</div>
							<div class="field-wrapper">
								<mat-checkbox formControlName="newsletter" id="newsletter">
									<span
										>{{ 'sf.module.auth.sign_up.newsletter_info' | translate }}

										<span *ngIf="viewData.showNewsletterInfo">{{
											'sf.module.auth.sign_up.newsletter_full_info' | translate
										}}</span>
										<a class="show-more" (click)="showMore($event)">{{
											(viewData.showNewsletterInfo
												? 'sf.module.auth.sign_up.show_less'
												: 'sf.module.auth.sign_up.show_more'
											) | translate
										}}</a>
									</span>
								</mat-checkbox>
							</div>
							<span class="required-fields-info">{{
								'sf.module.license.invoice_details.customer_details.required_fields' | translate
							}}</span>
						</div>
						<small class="additional-info">{{ 'sf.module.auth.sign_up.additional_info' | translate }}</small>
					</div>

					<button
						class="create"
						mat-flat-button
						color="accent"
						id="signUpButton"
						(click)="onCreateAccount()"
						[disabled]="viewData.formInvalid || viewData.loading"
					>
						{{ 'sf.module.auth.sign_up.create_account' | translate | uppercase }}
					</button>
					<div class="sign-up-separator"></div>
				</div>
				<div class="back-to-login-wrapper">
					<a class="link" routerLink="/">{{ 'sf.module.auth.common.back_to_login' | translate }}</a>
				</div>
				<ng-template #confirmation>
					<sf-verify-email [usedEmail]="emailControl.value"></sf-verify-email>
				</ng-template>
			</div>
		</div>
		<sf-contact-footer></sf-contact-footer>
	</div>
</ng-container>
